import React from 'react';
import { render } from 'react-dom';
import App from 'App';
import './styles/bundle.scss';


render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js